import AttachmentItemView, { AttachmentItemViewProps } from './AttachmentItem.view';
import React from 'react';

const AttachmentItem: React.FC<AttachmentItemViewProps> = (props) => {
    return <AttachmentItemView {...props}></AttachmentItemView>;
};
export default AttachmentItem;
